"use client";

import React from "react";

//Motion
import { motion } from "framer-motion";

//Types
import { ButtonProps } from "@/types";

//Styles
import * as S from "./styles";
import icons from "@/assets/svg";

function isIconName(icon: any): icon is keyof typeof icons {
  return typeof icon === "string" && icon in icons;
}

const Button: React.FC<ButtonProps> = ({
  className,
  text,
  onClick,
  widthFull = false,
  icon,
  isLoading,
  variant,
  small = false,
  type = "button",
  disabled = false,
}) => {
  // Ensure variant is one of the allowed values
  const allowedVariants = [
    "default",
    "danger",
    "warning",
    "success",
    "green",
  ] as const;
  const safeVariant:
    | "default"
    | "danger"
    | "warning"
    | "success"
    | "green"
    | undefined = allowedVariants.includes(variant as any)
    ? (variant as "default" | "danger" | "warning" | "success")
    : undefined;

  return (
    // <motion.div whileHover={{ scale: 0.9 }} whileTap={{ scale: 1 }} >
    <S.Button
      className={className}
      onClick={onClick}
      $widthFull={widthFull}
      $variant={safeVariant} // nova prop
      $small={small}
      type={type}
      disabled={disabled}
    >
      {isLoading ? (
        <S.Spinner />
      ) : (
        <>
          {isIconName(icon) ? <S.IconComponent name={icon} /> : icon}
          {text}
        </>
      )}
    </S.Button>
    // </motion.div>
  );
};

export default Button;
